export default __webpack_public_path__ + "static/case_study_home-405d10aa0665d48ee7b273f43d352671.png";